import $http from "../axios";

const state = {};

const getters = {};

const actions = {
  createBag(__, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`create-bag`, data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },
  updateBag(__, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`update-bag`, data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },
  deleteBag(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post(`delete-bag`, data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },
  getBags(__, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(`get-bags`, { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  getBag(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(`get-bag`, { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  bulkAddBagProducts(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("bulk-add-bag-products", data)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
